import { render, staticRenderFns } from "./NavBarDown.vue?vue&type=template&id=1bb3dafc&"
import script from "./NavBarDown.vue?vue&type=script&lang=ts&"
export * from "./NavBarDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkExternal: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/LinkExternal.vue').default})
